import { api } from "@/builders/axios";
import { id } from "./id";

const post = function (data: { option: string; is_answer: boolean }) {
  return api.post("questions/question-option", data);
};

export const question_option = {
  post,
  id,
};
